class DebugUtil {
  static DEBUG_CAT_FLOW = 'cat_flow';
  static DEBUG_CAT_ALL = 'cat_all';
  static DEBUG_CAT_ERRORS_GENERAL = 'cat_errors_general';
  static DEBUG_CAT_BASIC = 'cat_basic';
  static DEBUG_CAT_BLOKKADES = 'cat_blokkades';

  static aAllCategories = [
    DebugUtil.DEBUG_CAT_FLOW,
    DebugUtil.DEBUG_CAT_BASIC,
    DebugUtil.DEBUG_CAT_ERRORS_GENERAL,
    DebugUtil.DEBUG_CAT_BLOKKADES
  ];

  static exampleDebugCalls = () => {
    console.log('> exampleDebugCalls');
    // DebugUtil.profilerStart('mijn test');
    // DebugUtil.enableCategory(DebugUtil.DEBUG_CAT_FLOW);
    DebugUtil.enableCategory(DebugUtil.DEBUG_CAT_ALL);
    DebugUtil.log('Bericht in de categorie flow');

    DebugUtil.log('Bericht in de categorie basic', {
      sCategory: DebugUtil.DEBUG_CAT_BASIC
    });

    DebugUtil.log('Object context debug', {
      sCategory: DebugUtil.DEBUG_CAT_BASIC,
      oExtraContext: {
        dit: 'is mijn test',
        dat: ['is', 'een', 'array']
      }
    });

    DebugUtil.log('Dit bericht is heel belangrijk', {
      sCategory: DebugUtil.DEBUG_CAT_BASIC
    });

    DebugUtil.profilerAddTimeStamp('Test timestamp halverwege');
    DebugUtil.addToCounter('Paard');
    DebugUtil.warn('dit is een waarschuwing');
    DebugUtil.error('dit is een error');
    // DebugUtil.profilerEnd();
  };

  // https://www.javascriptjanuary.com/blog/fancy-function-parameters
  // https://wesbos.com/destructuring-objects/
  // En code hinting werkt daarmee gewoon in PHPStorm. Had ik al eens gezegd dat PHPStorm top is?
  static exampleDestructuringArguments = (aVerplichtArg, {
    sOptionalString = 'default',
    bIsTrue = false
  } = {}) => {
    DebugUtil.log(sOptionalString);
  };

  static aEnabledCategories = [];
  static enableCategory = (sCategory) => {
    if ( typeof sCategory !== 'string' ) return false;

    if ( sCategory === DebugUtil.DEBUG_CAT_ALL )
    {
      for ( let i = 0; i < DebugUtil.aAllCategories.length; ++i )
      {
        DebugUtil.enableCategory(DebugUtil.aAllCategories[i]);
      }
    }
    else
    {
      if ( DebugUtil.isCategoryEnabled(sCategory) === false )
      {
        DebugUtil.aEnabledCategories.push(sCategory);
      }
    }

    // console.log(DebugUtil.aEnabledCategories);
  };

  static isCategoryEnabled = (sCategory) => {
    if ( typeof sCategory !== 'string' ) return false;

    if ( DebugUtil.aEnabledCategories.indexOf(sCategory) > -1 ) return true;

    return false;
  };

  static sLastProcessedClass = false;
  static sLastProcessedMethod = false;

  static isThisNewClass = (sCallerClassAndMethod) => {
    if ( typeof sCallerClassAndMethod !== "string" ) return false;
    let aParts = sCallerClassAndMethod.split('.');
    if ( aParts.length < 2 ) return false;

    if ( aParts[0] !== DebugUtil.sLastProcessedClass )
    {
      DebugUtil.sLastProcessedClass = aParts[0];
      aParts.shift();
      DebugUtil.sLastProcessedMethod = aParts.join('.');

      return true;
    }

    return false;
  };

  static isThisNewMethod = (sCallerClassAndMethod) => {
    if ( typeof sCallerClassAndMethod !== "string" ) return false;
    let aParts = sCallerClassAndMethod.split('.');
    if ( aParts.length < 2 ) return false;

    aParts.shift();
    const sNewMethod = aParts.join('.');
// console.log('check new method', sNewMethod, DebugUtil.sLastProcessedMethod);
    if ( sNewMethod !== DebugUtil.sLastProcessedMethod )
    {
      DebugUtil.sLastProcessedMethod = sNewMethod;
      return true;
    }

    return false;
  };


  static _publish = (oMsg, {
    sCategory = DebugUtil.DEBUG_CAT_FLOW,
    sCallerClassAndMethod = null,
    oExtraContext = null,
    bAddStacktrace = false,
    bScream = false
  } = {}) => {

    let iExtraTopPadding = 0;
    let sPrefix = '';
    if ( DebugUtil.isThisNewClass(sCallerClassAndMethod) === true )
    {
      iExtraTopPadding = 5;
      sPrefix = '** ';
    }
    else if ( DebugUtil.isThisNewMethod(sCallerClassAndMethod) === true )
    {
      iExtraTopPadding = 2;
      sPrefix = '-- ';
    }

    let sTextColor = '#000';
    let sBgColor = '#FFF';
    let sMsg = '';

    switch ( sCategory )
    {
      case DebugUtil.DEBUG_CAT_FLOW:
        sTextColor = '#898989';
        sBgColor = '#FFF';
        break;
      case DebugUtil.DEBUG_CAT_BASIC:
        sTextColor = '#1ca416';
        sBgColor = '#FFF';
        break;
      case DebugUtil.DEBUG_CAT_ERRORS_GENERAL:
        sTextColor = '#d4007a';
        sBgColor = '#FFF';
        break;
    }

    let aStyles = [
      'background-color: ' + sBgColor,
      'color: ' + sTextColor,
      'display: block',
      'line-height: 15px',
      'padding-left: 0',
      'padding-top: ' + (10 + iExtraTopPadding) + 'px'
    ];

    if ( bScream === true )
    {
      aStyles.push('font-size: 24px');
      aStyles.push('font-weight: bold');
      aStyles.push('padding-bottom: 10px');
    }
    else
    {
      aStyles.push('font-size: 12px');
    }

    let sStyles = aStyles.join(';');

    sMsg = '%c ' + sPrefix + sCallerClassAndMethod + ': ' + oMsg;
    if ( oExtraContext === null )
    {
      console.log(sMsg, sStyles);
      if ( bAddStacktrace === true ) console.trace();
    }
    else
    {
      console.log(sMsg, sStyles);
      // DebugUtil.startGroup('Extra');
      console.groupCollapsed('Extra');
      if ( oExtraContext instanceof Array )
      {
        console.table(oExtraContext);
      }
      else if ( typeof oExtraContext === "object" )
      {
        console.dir(oExtraContext);
      }
      else
      {
        console.log(oExtraContext);
      }

      if ( bAddStacktrace === true ) console.trace();
      DebugUtil.endGroup('Extra');
    }
  };

  static startGroup = (sGroupName) => {
    if ( typeof sGroupName === 'undefined' ) sGroupName = 'default';
    console.group(sGroupName);
  };

  static endGroup = (sGroupName) => {
    if ( typeof sGroupName === 'undefined' ) sGroupName = 'default';
    console.groupEnd(sGroupName);
  };

  static getCallerClassFromError = (e) => {
    let sCallerClassName = 'onbekend';
    if ( typeof e === "undefined" ) return sCallerClassName;

    // console.log(e.stack);
    // return;

    // oude IE
    if ( typeof e === "undefined" || typeof e.stack === "undefined" ) return sCallerClassName;

    // Firefox heeft een andere opbouw van de error dan Chrome/Edge
    const sStack = e.stack;

    const aStackLines = sStack.split('\n');
    let sCallerClassLine = aStackLines[2];

    // "  at BookingApp._this.componentWillMount (BookingApp.js?86e2:31) <= Chrome/Edge
    // " BookingApp/_this.componentWillMount@webpack-internal:///./app/javascript/booking/containers/BookingApp.js:75:13" <= Firefox

    // als sCallerClassLine begint met spaties en dan 'at' dan is dit Chrome format.. zo niet dan hebben we een regel hoger nodig
    let sStackStyleToUse = 'unknown';
    if ( sCallerClassLine.trim().substr(0, 2) === 'at' )
    {
      sStackStyleToUse = 'chrome';
    }
    else
    {
      sStackStyleToUse = 'firefox';
    }

    if ( sStackStyleToUse === 'chrome' )
    {
      sCallerClassName = sCallerClassLine.replace(/^\s+at\s+(.+?)\s.+/g, '$1');
    }
    else if ( sStackStyleToUse === 'firefox' )
    {
      sCallerClassLine = aStackLines[1];
      sCallerClassName = sCallerClassLine.split('@')[0].replace('/', '.');
    }

    return sCallerClassName;
  };

  static log = (oMsg, {
    sCategory = DebugUtil.DEBUG_CAT_FLOW,
    oExtraContext = null,
    bAddStacktrace = false,
    bScream = false
  } = {}) => {

    const e = new Error('dummy');
    const sCallerClass = DebugUtil.getCallerClassFromError(e);

    // console.log(sStackStyleToUse);
    // console.log(sCallerClassLine);
    // console.log(sCallerClass);
    // console.log('-----');
    // return;
    // console.log(sCategory);
    if ( typeof sCategory === 'undefined' || sCategory === null ) sCategory = DebugUtil.DEBUG_CAT_BASIC;
    if ( typeof oExtraContext === 'undefined' ) oExtraContext = null;

    if ( DebugUtil.isCategoryEnabled(sCategory) )
    {
      DebugUtil._publish(oMsg, {
        sCategory: sCategory,
        sCallerClassAndMethod: sCallerClass,
        oExtraContext: oExtraContext,
        bAddStacktrace: bAddStacktrace,
        bScream: bScream
      });
    }
  };

  static warn = (oMsg, {
    sCategory = null,
    oExtraContext = null,
    bAddStacktrace = false
  } = {}) => {
    const e = new Error('dummy');
    const sCallerClass = DebugUtil.getCallerClassFromError(e);

    if ( typeof oExtraContext === 'undefined' ) oExtraContext = null;

    if ( DebugUtil.isCategoryEnabled(sCategory) || sCategory === null )
    {
      if ( oExtraContext !== null )
      {
        console.warn(sCallerClass, oMsg, sCategory, oExtraContext);
      }
      else
      {
        console.warn(sCallerClass, oMsg, sCategory);
      }

      if ( bAddStacktrace === true ) console.trace();
    }
  };

  static error = (oMsg, {
    sCategory = null,
    oExtraContext = null,
    bAddStacktrace = false
  }) => {
    const e = new Error('dummy');
    const sCallerClass = DebugUtil.getCallerClassFromError(e);


    // console.log(sCategory);
    if ( typeof oExtraContext === 'undefined' ) oExtraContext = null;

    if ( DebugUtil.isCategoryEnabled(sCategory) || sCategory === null )
    {
      if ( oExtraContext !== null )
      {
        console.error(sCallerClass, oMsg, sCategory, oExtraContext);
      }
      else
      {
        console.error(sCallerClass, oMsg, sCategory);
      }

      if ( bAddStacktrace === true ) console.trace();
    }
  };

  static addTimeStampToTimeline = (sName) => {
    if ( typeof sName === 'undefined' ) sName = 'default';
    console.timeStamp(sName)
  };

  static startTimer = (sTimerName) => {
    if ( typeof sTimerName === 'undefined' ) sTimerName = 'default';
    console.time(sTimerName);
  };

  static endTimer = (sTimerName) => {
    if ( typeof sTimerName === 'undefined' ) sTimerName = 'default';
    console.timeEnd(sTimerName);
  };

  static addToCounter = (sIdentifier, {
    bDoNotUseBackTrace = false
  } = {}) => {
    if ( typeof sIdentifier === 'undefined' ) sIdentifier = 'default';

    const e = new Error('dummy');
    let sCallerClass = "";

    if ( bDoNotUseBackTrace !== false )
    {
      sCallerClass = DebugUtil.getCallerClassFromError(e);
      sIdentifier = sCallerClass + ' count ' + sIdentifier;
    }

    console.count(sIdentifier);
  };

  static profilerStart = (sLabel) => {
    if ( typeof sLabel === 'undefined' ) sLabel = 'default';
    console.profile(sLabel);
  };

  static profilerEnd = () => {
    console.profileEnd();
  };

  static profilerAddTimeStamp = (sLabel) => {
    if ( typeof sLabel === 'undefined' ) sLabel = 'default';
    console.timeStamp(sLabel);
  };

  // static getCallerMethodName = () => {
  //   const e = new Error('dummy');
  //   const stack = e.stack
  //     .split('\n')[2]
  //   // " at functionName ( ..." => "functionName"
  //     .replace(/^\s+at\s+(.+?)\s.+/g, '$1');
  //
  //   return stack
  // };
}

export default DebugUtil;
